import React from 'react';
import styled from 'styled-components';

const CASTLE_PAGE_ID = 'f7be8040-b3de-43e8-a064-b173b1a8d761';
const GARDEN_PAGE_ID = '40ca044f-534f-4b7f-83ea-b4156f0633d3';

export const FESTIVE_TEA_BOOKING = {
  castle: `/booking-journey?locationId=978&pageId=${CASTLE_PAGE_ID}&requireAfternoonTea=1`,
  garden: `/booking-journey?locationId=978&pageId=${GARDEN_PAGE_ID}&requireAfternoonTea=1`,
};

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(10, 20, 40, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
`;

const Panel = styled.div`
  width: min(100%, 560px);
  background: #faf7f0;
  border-radius: 16px;
  padding: clamp(1.5rem, 4vw, 2rem);
  box-shadow: 0 24px 60px rgba(16, 29, 64, 0.28);
  position: relative;
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 0.85rem;
  right: 0.85rem;
  border: none;
  background: transparent;
  color: rgba(16, 29, 64, 0.45);
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  padding: 0.25rem 0.5rem;

  &:hover {
    color: #101d40;
  }
`;

const Kicker = styled.p`
  margin: 0 0 0.4rem;
  font-family: 'Inter', -apple-system, sans-serif;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #c9963c;
`;

const Title = styled.h2`
  margin: 0 0 0.65rem;
  font-family: ${p => p.theme?.fonts?.main || 'Georgia, serif'};
  font-size: clamp(1.55rem, 3.5vw, 1.9rem);
  font-weight: 700;
  color: #101d40;
  line-height: 1.15;
`;

const Lead = styled.p`
  margin: 0 0 1.35rem;
  font-family: 'Inter', -apple-system, sans-serif;
  font-size: 0.95rem;
  line-height: 1.6;
  color: rgba(28, 28, 30, 0.62);
`;

const Options = styled.div`
  display: grid;
  gap: 0.85rem;
`;

const OptionBtn = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  border: 1px solid rgba(28, 28, 30, 0.1);
  border-radius: 12px;
  background: #fff;
  padding: 1.1rem 1.2rem;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #c9963c;
    box-shadow: 0 6px 20px rgba(16, 29, 64, 0.08);
  }
`;

const OptionLabel = styled.div`
  font-family: ${p => p.theme?.fonts?.main || 'Georgia, serif'};
  font-size: 1.2rem;
  font-weight: 700;
  color: #101d40;
  margin-bottom: 0.3rem;
`;

const OptionMeta = styled.div`
  font-family: 'Inter', -apple-system, sans-serif;
  font-size: 0.85rem;
  line-height: 1.5;
  color: rgba(28, 28, 30, 0.62);
`;

const Note = styled.p`
  margin: 1.15rem 0 0;
  font-family: 'Inter', -apple-system, sans-serif;
  font-size: 0.8rem;
  line-height: 1.5;
  color: rgba(16, 29, 64, 0.5);
`;

/**
 * Choose Castle or Gardens entry before Festive Afternoon Tea booking.
 * Afternoon tea is an add-on; available 14 Nov – 30 Dec 2026.
 */
const FestiveAfternoonTeaEntryModal = ({ open, onClose }) => {
  if (!open) return null;

  const go = (url) => {
    window.location.href = url;
  };

  return (
    <Overlay
      role="dialog"
      aria-modal="true"
      aria-labelledby="festive-tea-entry-title"
      onClick={onClose}
    >
      <Panel onClick={(e) => e.stopPropagation()}>
        <CloseBtn type="button" onClick={onClose} aria-label="Close">
          ×
        </CloseBtn>
        <Kicker>Festive Afternoon Tea</Kicker>
        <Title id="festive-tea-entry-title">Choose your entry</Title>
        <Lead>
          Afternoon tea is an add-on — not included with entry. Pick Castle entry or Gardens &amp; Playground entry, then add Festive Afternoon Tea at checkout. Available 14 November – 30 December 2026.
        </Lead>
        <Options>
          <OptionBtn type="button" onClick={() => go(FESTIVE_TEA_BOOKING.castle)}>
            <OptionLabel>Castle entry</OptionLabel>
            <OptionMeta>
              Full Deck the Halls Castle visit — then add Festive Afternoon Tea at checkout.
            </OptionMeta>
          </OptionBtn>
          <OptionBtn type="button" onClick={() => go(FESTIVE_TEA_BOOKING.garden)}>
            <OptionLabel>Gardens &amp; Playground entry</OptionLabel>
            <OptionMeta>
              Gardens &amp; Playground day out — then add Festive Afternoon Tea at checkout.
            </OptionMeta>
          </OptionBtn>
        </Options>
        <Note>
          You&apos;ll select your date (14 Nov – 30 Dec) and add afternoon tea on the extras step.
        </Note>
      </Panel>
    </Overlay>
  );
};

export default FestiveAfternoonTeaEntryModal;
